import { UserMode } from '../enums';

export class EmailResult {
    public userId: number = 0;
    public userFullName: string = '';
    public userMode: UserMode = UserMode.CustomerEmployee;
    public email: string = '';

    // Front - End
    public id: number = 0;
    public fullNameAndEmail: string = '';
}
